module.exports = __webpack_public_path__ + "img/VI.90f6f1e2.svg";